// import Swiper JS
import Swiper from 'swiper';

function setCarouselMarginLeft(carouselBlock) {
    function updateMargin() {
        let $footer = document.querySelector('.page-footer');
        let $container = $footer.querySelector('.page-container');
        let mL = parseInt(window.getComputedStyle($container).marginLeft);
        let pL = parseInt(window.getComputedStyle($container).paddingLeft);
        let carouselElements = document.querySelectorAll(`.${carouselBlock}`);
        carouselElements.forEach(function(element) {
            element.style.marginLeft = (mL + pL) + 'px';
        });
    }

    window.addEventListener('load', updateMargin);
    window.addEventListener('resize', updateMargin);
}

const $clientsSwiper = new Swiper('.js-clients-slider', {
    //grabCursor: true,
    loop: false,
    speed: 900,
    slidesPerView: 'auto',
    spaceBetween: 35,
    breakpoints: {
        768: {
            spaceBetween: 60
        }
    },
    on: {
        touchStart: function () {
            const cursor = this.el.querySelector('.js-custom-drag-cursor');
            cursor.classList.add('touch');
        },
        touchMove: function () {
            const cursor = this.el.querySelector('.js-custom-drag-cursor');
            cursor.classList.add('touch');
        },
        touchEnd: function () {
            const cursor = this.el.querySelector('.js-custom-drag-cursor');
            cursor.classList.remove('touch');
        }
    }
});

window.addEventListener('resize', function () {
    if ($clientsSwiper.length) {
        $clientsSwiper.update();
    }
});

setCarouselMarginLeft('js-clients-slider');